import React from 'react';
import { connect } from 'react-redux';
import { withAdminLayout } from '../../common/admin-layout';
import { ADMIN_PAGES } from '../../assets/constants/global';
import { adminActions } from './admin-reducer';
import { BaseAdmin } from './base';
import { PROP_KEYS, ACTION_LOAD_TYPES, TEMPLATE_TYPES, ACTION_IMPORT_TYPES } from './admin-constants';

class AdminLocations extends React.Component {
    componentDidMount() {
        const { loadData } = this.props;

        loadData();
    }

    render() {
        const { 
            locations, locationsErrorMsg, handleDataPageChange, handleDataPageSizeChange,
            locationsPagination, isLoadedLocations, importData, exportData,
            setImportedData, downloadTemplate, cleanDataErrorMsg, handleSort,
            locationColumnTypes
        } = this.props;
        const baseProps = {
            data: locations,
            isLoaded: isLoadedLocations,
            errorMsg: locationsErrorMsg,
            handleImportData: importData,
            handleExportData: exportData,
            setImportedData: setImportedData,
            downloadTemplate: downloadTemplate,
            pagination: locationsPagination,
            handlePageChange: handleDataPageChange,
            handlePageSizeChange: handleDataPageSizeChange,
            cleanErrorMsg: cleanDataErrorMsg,
            sortData: handleSort,
            columnTypes: locationColumnTypes
        };

        return (
            <BaseAdmin {...baseProps} />
        );
    }
}

const mapStateToProps = (state) => {
    const { admin } = state;
    const { locations, locationsPagination, isLoadedLocations, locationsErrorMsg, locationColumnTypes } = admin;

    return {
        locations, isLoadedLocations, locationsPagination, locationsErrorMsg, locationColumnTypes
    };
}

const { action, isLoadedKey, paginationKey, dataKey, importAction, importedKey, errorMsgKey, fileKey, columnTypesKey } = {
    action: ACTION_LOAD_TYPES.location,
    isLoadedKey: PROP_KEYS.isLoadedLocations,
    paginationKey: PROP_KEYS.locationsPagination,
    dataKey: PROP_KEYS.locations,
    importAction: ACTION_IMPORT_TYPES.location,
    importedKey: PROP_KEYS.importedLocations,
    errorMsgKey: PROP_KEYS.locationsErrorMsg,
    fileKey: TEMPLATE_TYPES.Location,
    columnTypesKey: PROP_KEYS.locationColumnTypes
}

const mapDispatchToProps = {
    loadData: () => adminActions.load({ 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    importData: () => adminActions.importData({
        importAction, action, isLoadedKey, importedKey, errorMsgKey, paginationKey, dataKey
    }),
    exportData: () => adminActions.exportData({ 
        action, isLoadedKey, fileKey
    }),
    setImportedData: (file) => adminActions.setValue(importedKey, file),
    cleanDataErrorMsg: () => adminActions.setValue(errorMsgKey, []),
    downloadTemplate: () => adminActions.downloadTemplate({
        isLoadedKey, fileKey
    }),
    handleDataPageChange: (page, pageSize) => adminActions.handlePaginationChange(page, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleDataPageSizeChange: (_page, pageSize) => adminActions.handlePaginationChange(1, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleSort: (_pagination, _filters, sorter) => adminActions.handleSort(1, sorter, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    })
}

const connectedAdminLocations = connect(mapStateToProps, mapDispatchToProps)(withAdminLayout(AdminLocations, ADMIN_PAGES.AdminLocations));
export { connectedAdminLocations as AdminLocations };